import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from '../dataservice.service';
import { StateInfo } from '../state-list/state-list.component';

@Component({
  selector: 'app-state-form',
  templateUrl: './state-form.component.html',
  styleUrl: './state-form.component.css'
})
export class StateFormComponent implements OnInit {
  @Input() initialState: StateInfo | null = null;
  stateForm: FormGroup;
  // providerOptions = ['Provider A', 'Provider B', 'Provider C', 'Provider D'];
  stateOptions = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
    'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
    'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
    'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
    'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  constructor(private fb: FormBuilder, private dataService: DataserviceService) {
    this.stateForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      providers: [[], Validators.required],
      color: ['#000000', Validators.required]
    });
  }

  ngOnInit() {
    if (this.initialState) {
      this.stateForm.patchValue(this.initialState);
    }
  }

  getStateInfo() {
    if (this.stateForm.valid) {
      return this.stateForm.value;
    }
    return null;
  }

  submitForm() {
    if (this.stateForm.valid) {
      const formData = this.stateForm.value;
      this.dataService.postData(formData, 'coverage').subscribe(
        (response) => {
          console.log('Form submitted successfully:', response);
          // You can add logic here to handle successful submission (e.g., show a success message)
        },
        (error) => {
          console.error('Error submitting form:', error);
          // You can add logic here to handle errors (e.g., show an error message)
        }
      );
    }
  }

}

// export interface StateInfo {
//   id: string;
//   name: string;
//   providers: string[];
//   color: string;
// }
